export const CurrencySelector = {
  mounted() {
    this._select = this.el.querySelector("select")
    this._onChange = (e) => {
      this.pushEventTo(this.el, "currency_changed", {
        currency_code: e.target.value,
      })
    }
    this._select.addEventListener("change", this._onChange)
  },

  destroyed() {
    this._select.removeEventListener("change", this._onChange)
  },
}
